import { Fragment, useState, useEffect } from 'react';
import ContentLoader from 'react-content-loader';

const TableRowPlaceholder = (props) => {
    const random = Math.random() * (1 - 0.7) + 0.7;
    const [width, setWidth] = useState(850);

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth < 768 ? 300 : 850);
        };

        if (typeof window !== 'undefined') {
            handleResize();
        }

        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <ContentLoader
            height={60}
            width={width}
            speed={1}
            primaryColor='#EDEEF3'
            secondaryColor='#f3f3f3'
            {...props}
        >
            <rect x='0' y='13' rx='6' ry='6' width={width === 300 ? 120 * random : 300 * random} height='12' />
            <rect x='0' y='32' rx='6' ry='6' width={width === 300 ? 160 * random : 400 * random} height='12' />

            <rect x={width === 300 ? '203' : '553'} y='20' rx='6' ry='6' width={width === 300 ? 60 * random : 120 * random} height='12' />
            <rect x={width === 300 ? '275' : '855'} y='20' rx='6' ry='6' width={width === 300 ? 20 * random : 60 * random} height='12' />

            <rect x='0' y='58' rx='6' ry='6' width={width} height='.3' />
        </ContentLoader>
    );
};

const TablePlaceholder = (props) => {
    const { numberOfRows } = props || 10;
    let keyCounter = 0;
    return (
        <Fragment>
            {Array(numberOfRows)
                .fill('')
                .map((e, i) => (
                    <TableRowPlaceholder key={keyCounter++} style={{ opacity: Number(2 / i).toFixed(1) }} />
                ))}
        </Fragment>
    );
};



export default TablePlaceholder;
